import {rgElement} from '../rgElement/rg-element.js';

/**
 * the main class that gets exportet
 */
export class rgSearch extends rgElement {

    #rgNav = document.querySelectorAll('rg-nav');
    #searchPanel = null;
    #searchInput = null;
    #toggleButton = null;
    #internalToggleButton = true;
    #alwaysOpen = false;
    #overlayClose = null;
    #overlay = null;
    #isVisible = false;

    constructor() {
        super();
    }

    connectedCallback() {
        this.setUpElement();
        this.attachShadow({mode: 'open'});
        this.shadowRoot.innerHTML = this.#prepareHTML();
        this.classList.remove('.rg-search');

        this.#overlay = this.shadowRoot.querySelector('.rg-search__overlay');
        if (this.dataset.showoverlay === 'true') {
            this.#overlayClose = this.shadowRoot.querySelector('.rg-search__overlayclose');
            this.#overlayClose.addEventListener('click', this.hideSearch.bind(this));
            this.#overlay.addEventListener('click', this.hideSearch.bind(this));
            this.#overlay.style.display = 'block';
        }

        this.#searchPanel = this.shadowRoot.querySelector('.rg-search__wrapper');
        this.classList.forEach(classname => {
            if(classname !== 'rg-nav'){
                this.#searchPanel.classList.add(classname)
            }
        })

        this.#searchInput = this.shadowRoot.querySelector('.rg-search__input');

        if (this.dataset?.showtoggle !== undefined) {
        this.#internalToggleButton = this.dataset.showtoggle !== 'false';
        }
        if (this.dataset?.alwaysopen !== undefined) {
            this.#alwaysOpen = this.dataset.alwaysopen !== 'false';
        }
        if (this.#internalToggleButton) {
            this.#toggleButton = this.shadowRoot.querySelector('.rg-search__trigger');
            this.#toggleButton.addEventListener('click', function (ev) {
                ev.preventDefault();
                this.toggleSearch();
            }.bind(this));
            this.#overlay.style.display = 'none';
            this.style.display = 'block';
        } else {
            if (!this.#alwaysOpen) {
            this.style.display = 'none';
        }
        }

        if(document.readyState === 'complete'){
            this.attachToggleHandler();
        }
        else{
            window.onload = () => {
                this.attachToggleHandler();
            };
        }

        this.setupComplete();
    }

    attachToggleHandler(){
        let toggleIcons = document.querySelectorAll('*[data-toggle=' + this.tagName.toLowerCase() + ']');
        toggleIcons.forEach(function (toggleIcon) {
            toggleIcon.addEventListener('click', function (ev) {
                ev.preventDefault();
                this.toggleSearch();
            }.bind(this));
            toggleIcon.addEventListener('keydown', function (ev) {
                if (ev.keyCode === 32) {
                    ev.preventDefault();
                    this.toggleSearch();
                }
            }.bind(this));
        }.bind(this));
    }

    showSearch() {
        this.#isVisible = true;
        this.#searchPanel.style.display = '';
        this.#rgNav.forEach(nav => nav.hideNav());
        if (!this.#internalToggleButton) {
            this.style.display = 'block';
        } else {
            if (this.dataset.showoverlay === 'true') {
                this.#overlay.style.display = 'block';
            }
        }
        this.#searchInput.focus();
    }

    hideSearch() {
        this.#isVisible = false;
        this.#searchPanel.style.display = 'none';
        if (!this.#internalToggleButton) {
            this.style.display = 'none';
        } else {
            if (this.dataset.showoverlay === 'true') {
                this.#overlay.style.display = 'none';
            }
        }

    }

    toggleSearch() {
        if (!this.#isVisible) {
            this.showSearch();
        } else {
            this.hideSearch();
        }
    }

    getInputField() {
        return this.#searchInput;
    }

    /**
     * creates the html-markup for rg-search
     * @returns {string}
     */
    #prepareHTML() {
        /**
         * variables for templateHTML
         */
        const adoptedCSS = this.getStyles('.rg-search', '.rg-search__wrapper'),
            urlSearchParams = new URLSearchParams(window.location.search),
            params = Object.fromEntries(urlSearchParams.entries()),
            variables = {
                csspath: this.rootpath + '/css/rg-search.css',
                action: this.dataset.action || '/suche',
                placeholder: this.dataset.placeholder || 'Suchbegriff eingeben!',
                searchterm: decodeURIComponent(params.q || ''),
                customcss: this.dataset.customcss ? `<link rel="stylesheet" href="${this.dataset.customcss}">` : '',
                adoptedCSS: adoptedCSS !== '' ? '<style>' + adoptedCSS + '</style>' : '',
                buttontext: this.dataset.buttonText || 'SUCHE',
                togglebutton: this.dataset.showtoggle === 'false' ? '' : `<span class="rg-search__trigger" part="trigger"><li class="fas fa-search" aria-hidden="true"></li></span>`
            };
        return `
                <link rel="stylesheet" href="${variables.csspath}">
                ${variables.customcss}
                ${variables.adoptedCSS}
                ${variables.togglebutton}
                <div class="rg-search__overlay" part="overlay">
                    <div class="rg-search__overlayclose" part="overlayclose"></div>
                </div>
                <div class="rg-search__wrapper" part="wrapper">
                    <div class="rg-search__description" part="description"><slot name="description"></slot></div>
                    <form class="rg-search__form" method="GET" action="${variables.action}" part="form">
                        <input class="rg-search__input" name="q" placeholder="${variables.placeholder}" required="required" value="${variables.searchterm}" part="input">
                        <button class="rg-search__button" type="submit" part="button"><slot name="buttonContent">${variables.buttontext}</slot></button>
                    </form>
                </div>
            `;
    }
}